import { CookieConsentBanner } from './CookieConsentBanner';
import { CookieSettingsModal } from './CookieSettingsModal';

export function CookieManager() {
  return (
    <>
      <CookieConsentBanner />
      <CookieSettingsModal />
    </>
  );
}